import React from 'react';
import './Header.scss';
import logo from '../../images/LOGO.svg'; 

const Header = () => {
  return (
    <div className="header-container">
      <div className="header-row">
        <div className="header-col">
          <img src={logo} alt="Logo" className="header-logo" />
          <div className="header-title">Oil & Gas Trading Knowledge Management</div>
        </div>
      </div>
    </div>
  );
}

export default Header;
